module.exports = __webpack_public_path__ + "img/SomethingRotten22.e6944afd.png";